import { render, staticRenderFns } from "./BuyMeACoffee.vue?vue&type=template&id=6dc936b2&scoped=true"
import script from "./BuyMeACoffee.vue?vue&type=script&lang=js"
export * from "./BuyMeACoffee.vue?vue&type=script&lang=js"
import style0 from "./BuyMeACoffee.vue?vue&type=style&index=0&id=6dc936b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc936b2",
  null
  
)

export default component.exports